import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 端数処理 */
enum RoundingMethod {
  roundHalfUp = 'ROUND_HALF_UP',
  roundDown = 'ROUND_DOWN',
}

const nameConfig = {
  roundHalfUp: new Map([
    [Locale.ja, '四捨五入'],
    [Locale.en, 'Round Half Up'],
  ]),
  roundDown: new Map([
    [Locale.ja, '切り捨て'],
    [Locale.en, 'Round Down'],
  ]),
};

const toEnum = rawValueToEnum(RoundingMethod, RoundingMethod.roundHalfUp);
const toDisplay = enumToName(RoundingMethod, nameConfig);
const toDisplayWithPrefix = enumToName(RoundingMethod, nameConfig, { prefix: true });

export const roundingMethod = {
  enum: RoundingMethod,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { RoundingMethod };
